module.exports = "/assets/data/c313528321d188589c21b0988a4eda1b-CF64.data.json";